import Badge from "../../../../../../components/badges/Badge";
import {Tooltip} from "@heroui/react";

const badgeTypes = {
  yellow: { background: 'rgba(240, 160, 34, 0.1)', foreground: 'rgba(240, 160, 34, 0.2)', color: 'rgb(240, 170, 117, 0.6)' },
  green: { background: 'rgba(34, 197, 94, 0.1)', foreground: 'rgba(34, 197, 94, 0.2)', color: 'rgb(117 255 168 / 0.5)' },
  red: { background: 'rgba(197, 34, 34, 0.15)', foreground: 'rgba(197, 34, 34, 0.2)', color: 'rgb(255, 82, 82, 0.5)' },
};


export const LISIProgressBlock = ({ log }) => {
  // if (log.data_piece_id !== 472) return null;
  // console.log(log);
  const totalDuration = Math.max(
    (parseInt(log.data_pattern_oven_time) + parseInt(log.data_pattern_oven_tolerance)), // 20% margin
    parseInt(log.data_oven_time + log.data_oven_time_uncertainty)
  ) * 1.1;

  const percentPatternOvenTime = log.data_pattern_oven_time / totalDuration * 100;
  const percentPatternOvenTimeWithTolerance = (log.data_pattern_oven_time + log.data_pattern_oven_tolerance) / totalDuration * 100;

  const percentOvenTimeStart = (log.data_oven_time - log.data_oven_time_uncertainty) / totalDuration * 100;
  const percentOvenTimeWidth = 2 * log.data_oven_time_uncertainty / totalDuration * 100;

  const type = log.data_piece_status === 'conforme' ? 'green' : log.data_piece_status === 'non conforme' ? 'red' : 'yellow';

  const dataConformityConfidence = Math.floor(log.data_conformity_confidence * 1000) / 10;

  return (
    <div className="flex gap-2 items-center">
      <div className="relative h-4 w-full flex items-center rounded-md px-2 py-1 text-xs font-medium border-1"
           // style={{ background: 'rgba(90, 90, 90, 0.3)', borderColor: badgeTypes[type].foreground }}
           style={{ background: badgeTypes[type].background, borderColor: badgeTypes[type].foreground }}
      >
        <div className="absolute h-full"
             style={{
               left: percentPatternOvenTime + '%',
               right: 100 - percentPatternOvenTimeWithTolerance + '%',
               background: badgeTypes[type].foreground,
               borderLeft: '1px dashed ' + badgeTypes[type].foreground,
               borderRight: '1px dashed ' + badgeTypes[type].foreground,
             }}
        />
        <div className="absolute bg-red-500 rounded-md h-[50%] min-w-1"
             style={{
               left: percentOvenTimeStart + '%',
               width: percentOvenTimeWidth + '%',
               top: '25%',
               background: badgeTypes[type].color,
             }}
        />
      </div>
      <Tooltip
        content={`Statistiquement, la pièce a ${dataConformityConfidence}% de chance d'être comprise dans l'intervalle de tolérance et conforme.`}
        delay={0}
      >
        <span>
          <Badge text={`${dataConformityConfidence}%`} type="gray"/>
        </span>
      </Tooltip>
    </div>
  );
};
